// Lightweight Google Tag Manager dataLayer helper.
//
// The GTM container (GTM-PCVMGJTT) is loaded from index.html; this module just
// pushes events onto window.dataLayer. Every call is best-effort and wrapped so
// analytics can never break the UI. We attach role + school_code (non-PII) as
// default context so events can be segmented by tenant/role in GTM/GA4.

function context() {
  try {
    const ctx = {
      role: localStorage.getItem('swotify_role') || undefined,
      school_code:
        localStorage.getItem('swotify_school_code') ||
        localStorage.getItem('swotify_active_school_code') ||
        undefined,
    };
    // Attach the internal user id (NON-PII — no name/email) so GA4 can segment
    // "which teacher / which user" via User-ID. Read straight from the persisted
    // user blob to avoid a circular import on swotifyAuth.
    const raw = localStorage.getItem('swotify_current_user');
    if (raw) {
      const u = JSON.parse(raw);
      const id = u?.id ?? u?.user_id;
      if (id != null && id !== '') ctx.user_id = String(id);
      if (!ctx.role && u?.role) ctx.role = String(u.role);
    }
    return ctx;
  } catch {
    return {};
  }
}

/** Push a raw event to the dataLayer (no auto-context). */
export function pushEvent(event, params = {}) {
  try {
    if (typeof window === 'undefined' || !event) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  } catch {
    /* analytics must never throw into the UI */
  }
}

/** Track a user action, tagged with role + school_code context. */
export function trackEvent(event, params = {}) {
  pushEvent(event, { ...context(), ...params });
}

/** Track a SPA page view (HashRouter — fired on route change). */
export function trackPageView(path) {
  try {
    pushEvent('page_view', {
      ...context(),
      page_path: path,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
    });
  } catch {
    /* ignore */
  }
}
